import { render, staticRenderFns } from "./ProfilDaerahView.vue?vue&type=template&id=97a9195c&scoped=true"
import script from "./ProfilDaerahView.vue?vue&type=script&lang=js"
export * from "./ProfilDaerahView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a9195c",
  null
  
)

export default component.exports